// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"2197cf5c","618":"755a57bf","838":"6209d137"}[chunkId] + ".chunk.js";
};